module.exports = __webpack_public_path__ + "6ac273e3b88cf9db2be99516e5fab791.svg";